module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', _vm._l((_vm.articles), function(article) {
    return _c('li', {
      staticClass: "list",
      on: {
        "click": function($event) {
          _vm.pushArticleInfo()
        }
      }
    }, [_c('p', {
      staticClass: "list-top"
    }, [_c('a', {
      staticClass: "author",
      attrs: {
        "href": "#"
      }
    }, [_c('span', [_vm._v(_vm._s(article.author))])]), _c('span', {
      staticClass: "time"
    }, [_vm._v(" - " + _vm._s(article.time))])]), _vm._v(" "), _c('h2', {
      staticClass: "title"
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(article.title))])]), _vm._v(" "), _c('div', {
      staticClass: "small-text-group"
    }, [_c('span', {
      staticClass: "small-text"
    }, [_vm._v("阅读 " + _vm._s(article.read) + " -")]), _vm._v(" "), _c('span', {
      staticClass: "small-text"
    }, [_vm._v("评论 " + _vm._s(article.comment) + " -")]), _vm._v(" "), _c('span', {
      staticClass: "small-text"
    }, [_vm._v("喜欢 " + _vm._s(article.like) + " -")]), _vm._v(" "), _c('span', {
      staticClass: "small-text"
    }, [_vm._v("打赏 " + _vm._s(article.pay))])]), _vm._v(" "), _c('span', {
      staticClass: "image",
      style: ({
        backgroundImage: article.src,
        backgroundSize: '100%',
        backgroundRepeat: 'no-repat'
      })
    })])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bf26903"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/article.vue
// module id = 58
// module chunks = 0